<div class="container">
  <div class="row">
    <div class="col-lg-6">
      <div class="max d-flex flex-column gap mb-5">
        <h1 *ngIf="title" class="display-1">
          {{ title }}
        </h1>
        <div class="" [storyblokRichText]="content"></div>
      </div>
    </div>
    <div class="col-lg-6">
      <div class="motivator mb-3 mb-lg-5" *ngIf="contact_motivator">
        {{ contact_motivator }}
      </div>
      @defer {
      <app-form class="form"></app-form>
      } @placeholder (minimum 500ms) {
      <div></div>
      }
    </div>
  </div>
</div>
